import { List, IconTick, Text } from 'braid-design-system';

export const StandardFeatures = () => (
  <List type="icon" icon={<IconTick tone="formAccent" />}>
    {[
      'List until your business sells',
      'Photo included in search results',
      'Appear higher in search results',
      'Include in daily buyer recommendation emails',
    ].map((feature, i) => (
      <Text key={i}>{feature}</Text>
    ))}
  </List>
);
